<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title>Modifier l'email</v-card-title>
            <v-card-text>
                <v-text-field v-model="newEmail" label="Nouvel email" required />
            </v-card-text>
            <v-card-actions>
                <v-btn @click="updateEmail">Mettre à jour</v-btn>
                <v-btn @click="$emit('close')">Annuler</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from '@/store/AuthStore';
import snackbarService from '@/services/snackbarService.js';

const dialog = ref(true);
const newEmail = ref('');
const authStore = useAuthStore();

const updateEmail = async () => {
    if(await authStore.updateEmail(newEmail.value))
    {
        snackbarService.showSnackbar("E-mail mis à jour avec succès !", 'success')
        dialog.value = false;
    } else
    {
        snackbarService.showSnackbar("Erreur lors de la mise à jour de l'e-meil !", 'error')
    }
};
</script>